module.exports = __webpack_public_path__ + "img/TRACTOR_CHASSIS TRAILER_TUBE SKID_RHD.37d557c5.jpg";